import React from 'react';

import ProgressBar, { IProgressBarProps } from '~/components/atoms/ProgressBar';

import styles from './SubmitCollectionProgressBar.module.scss';

const SubmitCollectionProgressBar: React.FC<
  Omit<IProgressBarProps, 'isAnimated'>
> = ({ target, targetMax, value }) => (
  <div className={styles.container}>
    <span className={styles.valueContainer}>
      <div className={styles.value}>{value}</div>
      <div className={styles.target}>{`/${target}`}</div>
    </span>
    <ProgressBar
      target={target}
      targetMax={targetMax}
      value={value}
      isAnimated={false}
    />
  </div>
);

export default React.memo(SubmitCollectionProgressBar);
